import React, { useState } from "react";
import { Checkbox, Tag, Typography, Spin } from "antd";
import { nowUtcIso } from "./rampChecklistTime";
import MobileDateTimePicker from "./MobileDateTimePicker";

const { Text } = Typography;

/**
 * 单个检查项行：一个"完成"勾选框 + 一个日期时间（带日期，跨日不混）。
 * - 勾"完成"时，只要该项时间未被手动改过，就带出当前时间一并写回（取消后再勾会刷新成新的当前时间）；
 * - 手动改时间则把 time_manual 置 true 一并保存，之后勾"完成"不再覆盖时间；
 * - 取消"完成"不清空已记录的时间（时间是事实记录，与完成状态分开）。
 * 不做乐观翻转：等服务端返回后由上层更新状态，保证界面与服务端一致。
 * mobile=true 时加大行距、项名字号与时间框，便于手机点按。
 */
export default function ChecklistItemRow({ record, tzId, anchorDate, readOnly = false, mobile = false, onPatch }) {
    const [saving, setSaving] = useState(false);
    const attributes = record.attributes || {};

    const runPatch = async (fields) => {
        if (saving) return;
        setSaving(true);
        try {
            await onPatch(record.item_id, fields, record.lock_version);
        } finally {
            setSaving(false);
        }
    };

    const handleToggle = (event) => {
        const nextChecked = event.target.checked;
        const fields = { checked: nextChecked };
        // 勾上且未被手动改过 → 刷新为当前时间（含取消后再勾的场景）；手动值与取消动作都不动时间。
        if (nextChecked && !attributes.time_manual) {
            fields.time = nowUtcIso();
        }
        runPatch(fields);
    };

    const handleTimeChange = (iso) => {
        const fields = { time: iso, time_manual: true };
        if (iso && !attributes.checked) {
            fields.checked = true;
        }
        runPatch(fields);
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: mobile ? "14px 10px" : "10px 8px",
                borderBottom: "1px solid #f0f0f0",
                background: attributes.checked ? "#f6ffed" : "transparent",
                flexWrap: "wrap",
            }}
        >
            <Checkbox checked={!!attributes.checked} disabled={readOnly || saving} onChange={handleToggle} style={{ flex: "0 0 auto" }}>
                <span style={{ marginLeft: 4 }}>
                    <Text strong style={mobile ? { fontSize: 15 } : undefined}>
                        {attributes.label_en}
                    </Text>
                </span>
            </Checkbox>

            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>
                {saving && <Spin size="small" />}
                <MobileDateTimePicker
                    value={attributes.time}
                    onChange={handleTimeChange}
                    tzId={tzId}
                    anchorDate={anchorDate}
                    disabled={readOnly || saving}
                    placeholder="日期 时间"
                />
                {attributes.time_manual && (
                    <Tag color="purple" style={{ margin: 0 }}>
                        手动
                    </Tag>
                )}
            </div>
        </div>
    );
}
